import React, { FC } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

import { Checkbox, KeypointCollectionOptionContainer } from './KeypointCollectionOption.style';

interface IProps {
  keypointCollectionClass: any;
  setActiveKeypointCollectionClass: any;
  hotkey: any;
  isActive: any;
  isLabeled: any;
}

const KeypointCollectionOption: FC<IProps> = props => {
  const { keypointCollectionClass, setActiveKeypointCollectionClass, hotkey, isActive, isLabeled } =
    props;
  const label =
    keypointCollectionClass?.isRequired === false
      ? `${keypointCollectionClass?.value} (optional)`
      : keypointCollectionClass?.value;

  const handleKeypointCollectionOptionOnClick = () => {
    setActiveKeypointCollectionClass(keypointCollectionClass);
  };

  useHotkeys(hotkey, event => {
    event?.preventDefault();
    setActiveKeypointCollectionClass(keypointCollectionClass);
  });

  return (
    <KeypointCollectionOptionContainer
      isLabeled={isLabeled}
      isActive={isActive}
      onClick={handleKeypointCollectionOptionOnClick}
    >
      <Checkbox checked={isLabeled} readOnly />({hotkey}) {label}
    </KeypointCollectionOptionContainer>
  );
};

export default KeypointCollectionOption;
